var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home-page" },
    [
      _c("main-slider", { staticClass: "home-page__slider" }),
      _c(
        "div",
        { staticClass: "container" },
        [
          _c("banners-slot", {
            staticClass: "home-page__rowbanner2",
            attrs: { "with-category": false, "slot-name": "rowbanner2_main" }
          }),
          _c("banners-slot", {
            staticClass: "bottom-offset",
            attrs: { "with-category": false, "slot-name": "rowbanner4_main" }
          }),
          _c("product-gallery-slot", {
            staticClass: "home-page__popular_main",
            attrs: { "with-category": false, "slot-name": "popular_main" }
          }),
          _c("banners-slot", {
            staticClass: "home-page__bottom-offset",
            attrs: { "with-category": false, "slot-name": "rowbanner1_main" }
          }),
          _c("banners-slot", {
            staticClass: "home-page__bottom-offset",
            attrs: { "with-category": false, "slot-name": "rowbanner3_main" }
          }),
          _c("banners-slot", {
            staticClass: "bottom-offset",
            attrs: { "with-category": false, "slot-name": "rowbanner5_main" }
          }),
          _c("product-gallery-slot", {
            staticClass: "bottom-offset",
            attrs: { "with-category": false, "slot-name": "new_main" }
          }),
          _c("category-banners", {
            attrs: { "with-category": false, "slot-name": "category_main" }
          }),
          _c("advantages", { staticClass: "home-page__advantages" }),
          _c("publications-block", {
            attrs: { link: "", title: "Новости и акции" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }